document.addEventListener('DOMContentLoaded', initCheckoutPage);

function initCheckoutPage() {
  const root = document.querySelector('[data-checkout-page]');
  if (!root) return;

  const configEl = root.querySelector('[data-checkout-config]');
  const config = configEl ? JSON.parse(configEl.textContent) : {};
  const form = root.querySelector('[data-checkout-form]');
  if (!form) return;

  const itemsEl = root.querySelector('[data-checkout-items]');
  const subtotalEl = root.querySelector('[data-checkout-subtotal]');
  const totalEl = root.querySelector('[data-checkout-total]');
  const shippingEl = root.querySelector('[data-checkout-shipping]');
  const shippingHintEl = root.querySelector('[data-checkout-shipping-hint]');
  const submitBtn = root.querySelector('[data-checkout-submit]');
  const submitText = root.querySelector('[data-submit-text]');
  const submitIcon = root.querySelector('[data-submit-icon]');
  const submitNote = root.querySelector('[data-submit-note]');
  const discountInput = root.querySelector('[data-discount-input]');
  const discountApply = root.querySelector('[data-discount-apply]');
  const discountMsg = root.querySelector('[data-discount-msg]');

  const paymentTabs = root.querySelectorAll('[data-payment-tab]');
  const paymentPanels = root.querySelectorAll('[data-payment-panel]');
  let paymentMethod = 'card';
  let requestQueue = Promise.resolve();

  function enqueue(task) {
    const run = requestQueue.then(task, task);
    requestQueue = run.catch(() => {});
    return run;
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, config.moneyFormat);
    }
    return `$${(cents / 100).toFixed(2)}`;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function itemTitle(item) {
    if (item.variant_title && item.variant_title !== 'Default Title') {
      return `${item.product_title} — ${item.variant_title}`;
    }
    return item.product_title || item.title;
  }

  function updateHeaderCount(count) {
    const bubbleBtn = document.getElementById('cart-icon-bubble');
    if (!bubbleBtn) return;
    let bubble = bubbleBtn.querySelector('.site-header__cart-count');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('span');
        bubble.className = 'site-header__cart-count';
        bubbleBtn.appendChild(bubble);
      }
      bubble.textContent = count;
      bubble.hidden = false;
    } else if (bubble) {
      bubble.remove();
    }
  }

  function estimateShippingCents(subtotalCents) {
    const tiers = config.shippingTiers || [
      { min: 0, max: 14999, rate: 5000 },
      { min: 15000, max: 34999, rate: 2000 },
      { min: 35000, rate: 0 }
    ];

    for (const tier of tiers) {
      const min = tier.min ?? 0;
      const max = tier.max ?? Infinity;
      if (subtotalCents >= min && subtotalCents <= max) {
        return tier.rate;
      }
    }

    return 0;
  }

  function formatHint(template, values) {
    return String(template).replace(/\{(\w+)\}/g, (_, key) => values[key] ?? '');
  }

  function updateShippingDisplay(subtotalCents) {
    if (!shippingEl) return;
    const shippingCents = estimateShippingCents(subtotalCents);
    const strings = config.strings || {};
    shippingEl.textContent =
      shippingCents === 0 ? strings.shippingFree || 'Free' : formatMoney(shippingCents);
    shippingEl.classList.add('checkout-page__shipping-note--filled');
    if (totalEl) {
      totalEl.textContent = formatMoney(subtotalCents + shippingCents);
    }

    if (!shippingHintEl) return;

    if (subtotalCents >= 35000) {
      shippingHintEl.textContent =
        strings.shippingHintFreeUnlocked || "You've unlocked free shipping on this order.";
      shippingHintEl.hidden = false;
      return;
    }

    if (subtotalCents >= 15000) {
      shippingHintEl.textContent = formatHint(strings.shippingHintFree || 'Add {amount} more for free shipping.', {
        amount: formatMoney(35000 - subtotalCents)
      });
      shippingHintEl.hidden = false;
      return;
    }

    shippingHintEl.textContent = formatHint(
      strings.shippingHintReduce || 'Add {amount} more to reduce shipping to {rate}.',
      {
        amount: formatMoney(15000 - subtotalCents),
        rate: formatMoney(2000)
      }
    );
    shippingHintEl.hidden = false;
  }

  function setPaymentMethod(method) {
    paymentMethod = method;
    paymentTabs.forEach((tab) => {
      const active = tab.dataset.paymentTab === method;
      tab.classList.toggle('checkout-page__payment-tab--active', active);
    });
    paymentPanels.forEach((panel) => {
      const active = panel.dataset.paymentPanel === method;
      panel.hidden = !active;
      panel.setAttribute('aria-hidden', String(!active));
    });
    const strings = config.strings || {};
    if (submitText) {
      submitText.textContent =
        method === 'crypto'
          ? strings.payWithCrypto || 'Pay with Crypto'
          : strings.placeOrder || 'Place Order';
    }
    if (submitNote) {
      submitNote.textContent =
        method === 'crypto'
          ? submitNote.dataset.cryptoNote || submitNote.textContent
          : submitNote.dataset.cardNote || "You'll be redirected to secure checkout to pay with your card";
    }
    if (submitIcon) {
      submitIcon.innerHTML =
        method === 'crypto'
          ? '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11.767 19.089c4.924.868 6.14-6.025 1.216-6.894m-1.216 6.894L5.86 18.047m5.908 1.042-.347 1.97m1.563-8.864c4.924.869 6.14-6.025 1.215-6.893m-1.215 6.893-3.94-.694m5.155-6.2L8.29 4.26m5.908 1.042.348-1.97M7.48 20.364l3.126-17.727"/></svg>'
          : '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="20" height="14" x="2" y="5" rx="2"/><line x1="2" x2="22" y1="10" y2="10"/></svg>';
    }
  }

  function renderItems(cart) {
    if (!itemsEl) return;
    const items = cart.items || [];
    if (!items.length) {
      window.location.reload();
      return;
    }

    itemsEl.innerHTML = items
      .map((item, index) => {
        const title = escapeHtml(itemTitle(item));
        const borderClass = index < items.length - 1 ? ' checkout-page__receipt-item--border' : '';
        return `
          <div
            class="checkout-page__receipt-item${borderClass}"
            data-checkout-item
            data-line-key="${escapeHtml(item.key)}"
            data-testid="checkout-item-${item.variant_id}"
          >
            <div class="checkout-page__item-info">
              <p class="checkout-page__item-title">${title}</p>
              <p class="checkout-page__item-unit-price">${formatMoney(item.price)} / unit</p>
            </div>
            <div class="checkout-page__item-qty">
              <button type="button" class="checkout-page__qty-btn" data-qty-change="-1" aria-label="Decrease quantity">−</button>
              <span class="checkout-page__qty-value" data-qty>${item.quantity}</span>
              <button type="button" class="checkout-page__qty-btn" data-qty-change="1" aria-label="Increase quantity">+</button>
            </div>
            <span class="checkout-page__item-unit">${formatMoney(item.price)}</span>
            <div class="checkout-page__item-total-wrap">
              <span class="checkout-page__item-line-total">${formatMoney(item.line_price)}</span>
              <button
                type="button"
                class="checkout-page__item-remove"
                data-remove-item
                aria-label="Remove ${title}"
                data-testid="remove-item-${item.variant_id}"
              >
                <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
              </button>
            </div>
          </div>`;
      })
      .join('');

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price || 0);
    updateShippingDisplay(cart.items_subtotal_price || 0);
    updateHeaderCount(cart.item_count || 0);
  }

  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!res.ok) throw new Error('Failed to load cart');
    return res.json();
  }

  function changeItem(lineKey, quantity) {
    return enqueue(async () => {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: lineKey, quantity })
      });
      if (!res.ok) throw new Error('Failed to update cart');
      const cart = await res.json();
      renderItems(cart);
      return cart;
    });
  }

  function applyDiscount(code) {
    return enqueue(async () => {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ discount: code })
      });
      const cart = await res.json();
      if (!res.ok) {
        const msg = cart.description || cart.message || 'Invalid discount code';
        throw new Error(msg);
      }
      renderItems(cart);
      return cart;
    });
  }

  const COUNTRY_ISO_MAP = {
    'United States': 'US',
    Canada: 'CA',
    'United Kingdom': 'GB',
    Australia: 'AU',
    Germany: 'DE',
    France: 'FR',
    Netherlands: 'NL'
  };

  function resolveCountryIso(countryName) {
    const trimmed = String(countryName || '').trim();
    if (!trimmed || trimmed === 'Other') return '';
    if (COUNTRY_ISO_MAP[trimmed]) return COUNTRY_ISO_MAP[trimmed];
    if (/^[A-Z]{2}$/i.test(trimmed)) return trimmed.toUpperCase();
    return '';
  }

  function appendCheckoutPrefillParams(checkoutUrl, checkoutForm) {
    const baseUrl = (checkoutUrl || '/checkout').trim() || '/checkout';
    const data = new FormData(checkoutForm);
    const params = new URLSearchParams();

    const setParam = (key, value) => {
      const trimmed = String(value || '').trim();
      if (trimmed) params.set(key, trimmed);
    };

    setParam('checkout[email]', data.get('email'));
    setParam('checkout[shipping_address][first_name]', data.get('first_name'));
    setParam('checkout[shipping_address][last_name]', data.get('last_name'));
    setParam('checkout[shipping_address][address1]', data.get('address'));
    setParam('checkout[shipping_address][address2]', data.get('apt'));
    setParam('checkout[shipping_address][city]', data.get('city'));
    setParam('checkout[shipping_address][zip]', data.get('zip'));
    setParam('checkout[shipping_address][province]', data.get('state'));
    setParam('checkout[shipping_address][country]', resolveCountryIso(data.get('country')));

    if (!params.toString()) return baseUrl;

    try {
      const url = new URL(baseUrl, window.location.origin);
      params.forEach((value, key) => {
        url.searchParams.set(key, value);
      });
      return url.toString();
    } catch {
      const separator = baseUrl.includes('?') ? '&' : '?';
      return `${baseUrl}${separator}${params.toString()}`;
    }
  }

  function collectAttributes() {
    const data = new FormData(form);
    const apt = data.get('apt');
    const address = data.get('address');
    const fullAddress = apt ? `${address}, ${apt}` : address;

    return {
      'First Name': data.get('first_name') || '',
      'Last Name': data.get('last_name') || '',
      Email: data.get('email') || '',
      Phone: data.get('phone') || '',
      Country: data.get('country') || '',
      Address: fullAddress || '',
      City: data.get('city') || '',
      'ZIP Code': data.get('zip') || '',
      State: data.get('state') || '',
      'Payment Method': paymentMethod === 'crypto' ? 'Cryptocurrency' : 'Credit Card'
    };
  }

  function buildCryptoPayload(cart, attributes) {
    const formData = new FormData(form);
    const items = (cart.items || []).map((item) => ({
      productId: item.product_id,
      variantId: item.variant_id,
      name: itemTitle(item),
      price: item.price / 100,
      quantity: item.quantity
    }));
    const totalCents = cart.total_price || 0;
    const payload = {
      firstName: attributes['First Name'],
      lastName: attributes['Last Name'],
      email: attributes.Email,
      phone: attributes.Phone,
      country: attributes.Country,
      address: formData.get('address') || '',
      apt: formData.get('apt') || '',
      city: attributes.City,
      state: attributes.State,
      zip: attributes['ZIP Code'],
      items,
      total: `$${(totalCents / 100).toFixed(2)}`,
      totalAmount: totalCents / 100,
      currency: cart.currency || config.currency || 'USD',
      cartToken: cart.token
    };

    const payCurrency = (config.payCurrency || '').trim().toLowerCase();
    if (payCurrency) {
      payload.payCurrency = payCurrency;
    }

    return payload;
  }

  async function submitCryptoPayment(cart, attributes) {
    const apiUrl = (config.cryptoApiUrl || '').trim();
    const strings = config.strings || {};

    if (!apiUrl) {
      throw new Error(strings.cryptoNotConfigured || 'Crypto payment API is not configured.');
    }

    const payload = buildCryptoPayload(cart, attributes);
    const payRes = await fetch(apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });

    const data = await payRes.json().catch(() => ({}));
    if (!payRes.ok) {
      throw new Error(data.message || strings.paymentFailed || 'Crypto payment setup failed.');
    }
    if (!data.invoiceUrl) {
      throw new Error(strings.noInvoiceUrl || 'Payment link was not returned.');
    }

    if (window.MetaPixelEvents) {
      window.MetaPixelEvents.trackPurchaseOnce({
        orderRef: `CRYPTO-${cart.token}`,
        total: cart.total_price,
        currency: cart.currency || config.currency,
        items: cart.items || []
      });
    }

    window.location.href = data.invoiceUrl;
  }

  function buildOrderContactBody(cart, attributes, orderRef) {
    const items = (cart.items || [])
      .map((item) => {
        const title = itemTitle(item);
        const lineTotal = formatMoney(item.line_price || 0);
        const unitPrice = formatMoney(item.final_price || item.price || 0);
        return `- ${title} x${item.quantity} (${unitPrice} each) = ${lineTotal}`;
      })
      .join('\n');

    return [
      `New order submitted: ${orderRef}`,
      '',
      'Customer',
      `Name: ${[attributes['First Name'], attributes['Last Name']].filter(Boolean).join(' ')}`,
      `Email: ${attributes.Email || ''}`,
      `Phone: ${attributes.Phone || ''}`,
      '',
      'Shipping',
      `Country: ${attributes.Country || ''}`,
      `Address: ${attributes.Address || ''}`,
      `City: ${attributes.City || ''}`,
      `State: ${attributes.State || ''}`,
      `ZIP: ${attributes['ZIP Code'] || ''}`,
      '',
      'Payment',
      `Method: ${attributes['Payment Method'] || ''}`,
      '',
      'Items',
      items || 'No items',
      '',
      `Subtotal: ${formatMoney(cart.items_subtotal_price || 0)}`,
      `Total: ${formatMoney(cart.total_price || 0)}`
    ].join('\n');
  }

  async function parseContactResponse(response) {
    if (response.redirected && response.url.includes('/challenge')) {
      return { ok: false, error: 'Verification required (Shopify challenge).' };
    }

    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
      const data = await response.json();
      if (data.status || response.ok) return { ok: true };
      const err = data.errors || data.description || data.message;
      return { ok: false, error: typeof err === 'string' ? err : JSON.stringify(err) };
    }

    const text = await response.text();
    if (text.includes('h-captcha') || text.includes('/challenge')) {
      return { ok: false, error: 'Verification required (hCaptcha).' };
    }

    if (response.ok) return { ok: true };
    return { ok: false, error: text.slice(0, 500) || `HTTP ${response.status}` };
  }

  function getNotifyIframe(fresh) {
    if (fresh) {
      const existing = document.getElementById('order-notify-iframe');
      if (existing) existing.remove();
    } else {
      const frame = document.getElementById('order-notify-iframe');
      if (frame) return frame;
    }

    const frame = document.createElement('iframe');
    frame.id = 'order-notify-iframe';
    frame.name = 'order-notify-iframe';
    frame.hidden = true;
    frame.setAttribute('tabindex', '-1');
    frame.setAttribute('aria-hidden', 'true');
    document.body.appendChild(frame);
    return frame;
  }

  function getLatestContactRequestStatus() {
    const entries = performance
      .getEntriesByType('resource')
      .filter((entry) => entry.name.includes('/contact'))
      .sort((a, b) => b.responseEnd - a.responseEnd);

    const latest = entries[0];
    if (!latest || !latest.responseStatus) return null;
    return latest.responseStatus;
  }

  function initOrderNotifyCaptcha() {
    const notifyForm = document.querySelector('[data-order-notify-form]');
    if (!notifyForm || notifyForm.dataset.captchaInit === 'true') return;

    const captcha = window.Shopify && window.Shopify.captcha;
    if (!captcha || typeof captcha.protect !== 'function') return;

    notifyForm.dataset.captchaInit = 'true';
    captcha.protect(notifyForm);
  }

  function prewarmOrderNotifyCaptcha() {
    initOrderNotifyCaptcha();

    const notifyForm = document.querySelector('[data-order-notify-form]');
    if (!notifyForm || notifyForm.dataset.captchaWarmed === 'true') return;

    notifyForm.dataset.captchaWarmed = 'true';
    const field = notifyForm.querySelector('[data-notify-email]');
    if (field) field.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
  }

  async function postContactParams(action, params) {
    const response = await fetch(action, {
      method: 'POST',
      body: params,
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    const result = await parseContactResponse(response);
    if (!result.ok) {
      return { ok: false, error: `HTTP ${response.status}: ${result.error}` };
    }

    return { ok: true };
  }

  function submitNotifyFormViaIframe(notifyForm) {
    return new Promise((resolve, reject) => {
      const captcha = window.Shopify && window.Shopify.captcha;
      const iframe = getNotifyIframe(true);
      const timeoutId = window.setTimeout(() => {
        finish(false, 'Notification timed out');
      }, 20000);

      let submitted = false;
      let settled = false;

      function cleanup() {
        window.clearTimeout(timeoutId);
        iframe.removeEventListener('load', onLoad);
        notifyForm.removeAttribute('target');
      }

      function finish(ok, error) {
        if (settled) return;
        settled = true;
        cleanup();
        if (ok) resolve({ ok: true });
        else reject(new Error(error));
      }

      function onLoad() {
        if (!submitted) return;

        window.setTimeout(() => {
          const status = getLatestContactRequestStatus();
          if (status && status >= 400) {
            finish(false, 'Contact form rejected');
            return;
          }
          finish(true);
        }, 100);
      }

      iframe.addEventListener('load', onLoad);
      notifyForm.target = iframe.name;

      const submitNative = () => {
        submitted = true;
        notifyForm.submit();
      };

      if (captcha && typeof captcha.protect === 'function') {
        captcha.protect(notifyForm, submitNative);
        return;
      }

      submitNative();
    });
  }

  async function submitNotifyFormWithCaptcha(notifyForm) {
    const captcha = window.Shopify && window.Shopify.captcha;
    const action = notifyForm.getAttribute('action') || '/contact#contact_form';
    const params = new URLSearchParams(new FormData(notifyForm));

    if (!captcha || typeof captcha.protect !== 'function') {
      return postContactParams(action, params);
    }

    try {
      await submitNotifyFormViaIframe(notifyForm);
      return { ok: true };
    } catch {
      return { ok: false };
    }
  }

  async function submitShopifyContactNotification(cart, attributes, orderRef) {
    const notify = config.contactNotify || {};
    if (!notify.enabled) return;

    const customerEmail = (attributes.Email || '').trim();
    if (!customerEmail) return;

    const notifyForm = document.querySelector('[data-order-notify-form]');
    if (!notifyForm) return;

    const name =
      [attributes['First Name'], attributes['Last Name']].filter(Boolean).join(' ').trim() || 'Customer';
    const body = buildOrderContactBody(cart, attributes, orderRef);

    const emailEl = notifyForm.querySelector('[data-notify-email]');
    const nameEl = notifyForm.querySelector('[data-notify-name]');
    const phoneEl = notifyForm.querySelector('[data-notify-phone]');
    const bodyEl = notifyForm.querySelector('[data-notify-body]');

    if (emailEl) emailEl.value = customerEmail;
    if (nameEl) nameEl.value = name;
    if (phoneEl) phoneEl.value = (attributes.Phone || '').trim();
    if (bodyEl) bodyEl.value = body;

    try {
      await submitNotifyFormWithCaptcha(notifyForm);
    } catch {
      // Do not block checkout if email notification fails.
    }
  }

  async function submitOrder() {
    const required = form.querySelectorAll('[required]');
    for (const field of required) {
      if (!field.value.trim()) {
        field.focus();
        field.reportValidity();
        return;
      }
    }

    if (submitBtn) submitBtn.disabled = true;

    try {
      const attributes = collectAttributes();
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes })
      });
      if (!res.ok) throw new Error('Failed to save order details');
      const cart = await res.json();

      if (paymentMethod === 'crypto') {
        if (config.customCheckout?.enabled && config.customCheckout?.confirmUrl) {
          let orderRef = '';
          if (window.CheckoutOrderStorage) {
            const snapshot = window.CheckoutOrderStorage.save(cart, attributes);
            orderRef = snapshot.orderRef || '';
          }

          await submitShopifyContactNotification(cart, attributes, orderRef);
          window.location.href = config.customCheckout.confirmUrl;
          return;
        }

        await submitCryptoPayment(cart, attributes);
        return;
      }

      window.location.href = appendCheckoutPrefillParams(
        cart.checkout_url || config.checkoutUrl || '/checkout',
        form
      );
    } catch (err) {
      if (submitBtn) submitBtn.disabled = false;
      alert(err.message || 'Something went wrong. Please try again.');
    }
  }

  paymentTabs.forEach((tab) => {
    tab.addEventListener('click', () => setPaymentMethod(tab.dataset.paymentTab));
  });

  if (submitNote) {
    submitNote.dataset.cryptoNote = submitNote.dataset.cryptoNote || submitNote.textContent;
  }
  setPaymentMethod('card');

  initOrderNotifyCaptcha();
  form.addEventListener('focusin', prewarmOrderNotifyCaptcha, true);

  updateShippingDisplay(config.initialSubtotal || 0);

  if (itemsEl) {
    itemsEl.addEventListener('click', (e) => {
      const row = e.target.closest('[data-checkout-item]');
      if (!row) return;
      const lineKey = row.dataset.lineKey;
      if (!lineKey) return;

      if (e.target.closest('[data-remove-item]')) {
        changeItem(lineKey, 0);
        return;
      }

      const qtyBtn = e.target.closest('[data-qty-change]');
      if (!qtyBtn) return;
      const delta = Number(qtyBtn.dataset.qtyChange) || 0;
      const qtyEl = row.querySelector('[data-qty]');
      const current = Number(qtyEl?.textContent) || 1;
      const next = Math.max(0, current + delta);
      changeItem(lineKey, next);
    });
  }

  if (discountApply && discountInput) {
    discountApply.addEventListener('click', () => {
      const code = discountInput.value.trim();
      if (!code) return;
      discountApply.disabled = true;
      if (discountMsg) {
        discountMsg.hidden = true;
        discountMsg.classList.remove('checkout-page__discount-msg--error', 'checkout-page__discount-msg--success');
      }
      applyDiscount(code)
        .then(() => {
          if (discountMsg) {
            discountMsg.textContent = 'Discount applied';
            discountMsg.classList.add('checkout-page__discount-msg--success');
            discountMsg.hidden = false;
          }
        })
        .catch((err) => {
          if (discountMsg) {
            discountMsg.textContent = err.message;
            discountMsg.classList.add('checkout-page__discount-msg--error');
            discountMsg.hidden = false;
          }
        })
        .finally(() => {
          discountApply.disabled = false;
        });
    });
  }

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    submitOrder();
  });

  fetchCart()
    .then((cart) => {
      if ((cart.item_count || 0) > 0 && window.MetaPixelEvents) {
        window.MetaPixelEvents.trackInitiateCheckout(cart);
      }
    })
    .catch(() => {});
}
